import {
  UPDATE_SCREENSHOT_COMPLETE,
  UPDATE_SHARE_SCREENSHOT,
  UPDATE_SHARE_SCREENSHOT_URL,
} from 'constants/actions';

const DEFAULT_STATE = {
  screenshot: null,

  url: null,
  complete: false,
};

const shareScreenshotReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_SHARE_SCREENSHOT:
      return {
        ...state,
        screenshot: action.screenshot,
        current_user_is_owner:
          action.screenshot && action.screenshot.current_user_is_owner,
      };
    case UPDATE_SHARE_SCREENSHOT_URL:
      return {
        ...state,
        screenshot: { ...state.screenshot, url: action.url },
      };
    case UPDATE_SCREENSHOT_COMPLETE:
      return {
        ...state,
        complete: action.complete,
      };
    default:
      return state;
  }
};

export default shareScreenshotReducer;
